module.exports = __webpack_public_path__ + "static/media/0322_IMG_LES_MURS_PNO7_ROUGE_ROSSO_HORIZONTALE.59a4248e.webp";